// extracted by mini-css-extract-plugin
export default {"root":"UserLayout_root__JTOWI","small":"UserLayout_small__QzyI7","content":"UserLayout_content__ZZBFS","isMobile":"UserLayout_isMobile__06pNu"};